/**
 * author: Alex Lai
 * Support Website: https://laialex.com
 * Email: alex@laialex.com
 * Create Time: 2024/9/13
 */
import React, { Component } from 'react'
import * as ui from 'antd'
import apis from '../../../../utils/apis'
import { BellOutlined } from '@ant-design/icons'
import { PageHeader } from '@ant-design/pro-layout';
import { LoadingEnded, LoadingStart } from '../../../../utils/loading'


const { TextArea } = ui.Input
const { Option } = ui.Select

export default class Record extends Component {
  constructor() {
    super()
    this.state = {
      tableData: [],
      paging: { total: 0, pageNumber: 1, pageSize: 20 },
      tableLoad: false,
      searchKey: {},
      editShow: false,
      editCurr: {},
      submitting: false,
      htmlContent: "",
      htmlShow: false
    }
  }

  componentDidMount() {
    this.tableDataSync(1)
  }


  /**
   * 发起搜索
   * @param params
   * @constructor
   */
  makeSearch = (params) => {
    this.setState({
      searchKey: params
    })
    var that = this
    setTimeout(function() {
      that.tableDataSync()
    }, 200)
  }
  /**
   * 签名列表
   * @param pageNumber
   Object.assign(para, that.state.keywords)
   * @param pageSize
   * @constructor
   */
  tableDataSync = (pageNumber = 1) => {
    let that = this
    let para = {}
    para.pageNumber = pageNumber
    para.pageSize = 20
    that.setState({
      tableLoad: true
    })
    Object.assign(para, that.state.searchKey)
    apis.messagePushHistory(para).then(function(resp) {
      that.setState({
        tableLoad: false
      })
      var curr = {
        total: resp.data.data.total,
        pageNumber: pageNumber
      }
      that.setState({
        tableData: resp.data.data.data,
        paging: curr
      })
    })
  }


  render() {
    var that = this

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id'
      },
      {
        title: '进度',
        key: 'id',
        render: function(value, row, index) {
          return (
            <ui.Button size={'small'} shape={'round'} type={'dashed'} danger={true}>{row.state_text}</ui.Button>
          )
        }
      },
      {
        title: "发信时间",
        key: "id",
        render: function (value, row, index) {
          var dd = new Date(row.created_at)
          return `${dd.toLocaleDateString()} ${dd.toLocaleTimeString()}`
        }
      },
      {
        title: '群发消息',
        key: 'id',
        render: function(value, row, index) {
          return <ui.Button shape={'circle'} type={'primary'} danger={row.account.is_group}>{row.account.is_group ? '是' : '否'}</ui.Button>
        }
      },
      {
        title: '通道',
        key: 'id',
        render: function(value, row, index) {
          return row.account.push_channel.id
        }
      },
      {
        title: '受众',
        key: 'id',
        render: function(value, row, index) {
          return row.account.show_name
        }
      },
      {
        title: '绑定帐户',
        key: 'id',
        render: function(value, row, index) {
          return row.account.user_name
        }
      },
      {
        title: '内容',
        key: 'id',
        render: function(value, row, index) {
          return <div>
            {row.msg_type === "html" ? <ui.Button type={"link"} onClick={() => {
              that.setState({
                htmlContent: row.arguments,
                htmlShow: true
              })
            }}>
              点击查询
            </ui.Button> : <b>{row.arguments}</b>
            }
          </div>
        }
      },
      {
        title: '已生效',
        key: 'id',
        render: function(value, row, index) {
          return (
            <ui.Button shape={'circle'} type={'dashed'} size={'small'}>{row.effected ? '是' : '否'}</ui.Button>
          )
        }
      },
      {
        title: '报错信息',
        key: 'id',
        fixed: 'right',
        render: function(value, row, index) {
          return row.ret_msg
        }
      },
      {
        title: '操作',
        key: 'id',
        fixed: 'right',
        render: function(value, row, index) {

          return (
            <span>
              {!row.effected &&
                <ui.Button
                  onClick={() => {
                    LoadingStart()
                    apis.messagePushResend(row.id).then(res => {
                      LoadingEnded()
                      if (res.data.code === 200) {
                        ui.message.success('消息推送成功')
                        that.tableDataSync(that.state.paging.pageNumber)
                      } else {
                        ui.message.error(res.data.msg)
                      }
                    })
                  }}
                  shape={'round'}
                  type={'link'}>
                  重新发送
                </ui.Button>
              }
              {['fileUrl'].includes(row.msg_type) &&
                <ui.Button onClick={() => {
                  const link = document.createElement('a')
                  link.href = row.arguments
                  link.download = `${row.name}.${row.arguments.substring(row.arguments.lastIndexOf('.') + 1)}`
                  link.target = '_blank'
                  link.click()
                }} type={'link'}>文件下载</ui.Button>
              }
              {['fileUrl'].includes(row.msg_type) && ['xls', 'xlsx', 'csv'].includes(row.arguments.substring(row.arguments.lastIndexOf('.') + 1)) &&
                <ui.Button onClick={() => {
                  var targetUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURI(row.arguments)}`
                  const link = document.createElement('a')
                  link.href = targetUrl
                  link.target = '_blank'
                  link.click()
                }} type={'link'}>在线查看</ui.Button>
              }
            </span>

          )
        }
      }
    ]

    return (
      <div>
        <PageHeader title="消息推送历史记录" subTitle="详细记录消息推送的信息以及失败原因，推送状态等" />
        <ui.Card>
          <div style={{ marginTop: '22px' }}>
            <ui.Form onFinish={that.makeSearch} layout={'inline'}>
              <ui.Form.Item label={'收件人'} name={'account__show_name__contains'}>
                <ui.Input placeholder={'收件人'} />
              </ui.Form.Item>
              <ui.Form.Item>
                <ui.Button type={'primary'} htmlType={'submit'}>快速搜索</ui.Button>
              </ui.Form.Item>
            </ui.Form>
          </div>
        </ui.Card>

        <div style={{ marginTop: '22px' }}>
          <ui.Table
            rowKey="id"
            dataSource={this.state.tableData}
            columns={columns}
            loading={this.state.tableLoad}
            pagination={{
              total: this.state.paging.total,
              defaultPageSize: 20,
              defaultCurrent: this.state.paging.pageNumber,
              onChange: this.tableDataSync
            }} />
        </div>
        <ui.Modal open={that.state.htmlShow} title={'消息内容'} onCancel={() => {
          that.setState({
            htmlShow: false,
            htmlContent: ''
          })
        }}>
          <div style={{ padding: '12px' }}>
            <div dangerouslySetInnerHTML={{ __html: that.state.htmlContent }} />
          </div>
        </ui.Modal>
      </div>
    )
  }
}